import { createAction } from 'typesafe-actions';

import {
  SET_POST_LOGIN_REDIRECT,
  SET_TOKEN,
  START_LOGIN,
  START_LOGOUT,
  START_VERIFY,
} from './constants';

export const setToken = createAction(
  SET_TOKEN,
  (payload: string | null) => payload,
)();

// Stores or clears the path the user should land on after auth completes.
// Cleared with `null` once consumed by the post-token navigation effect.
export const setPostLoginRedirect = createAction(
  SET_POST_LOGIN_REDIRECT,
  (payload: string | null) => payload,
)();

// `redirectTo` is the path the user originally requested before the auth
// bounce. The startLogin saga forwards it as OIDC `state.redirectTo` so it
// survives the IdP roundtrip and is restored by startVerifySaga.
export const startLogin = createAction(
  START_LOGIN,
  (payload: { redirectTo?: string } = {}) => payload,
)();
export const startLogout = createAction(START_LOGOUT)();

export const startVerify = createAction(
  START_VERIFY,
  (payload: { savedToken?: string }) => payload,
)();
